import * as React from 'react';
import { useSelector } from 'react-redux';
import { useIsDesktop } from '@cian/valuation-utils-component';

import { getAuthor } from '../../selectors/author';

import { AgentContacts } from '../../components/AgentContacts';
import { getFormattedPhone } from '../../utils/getFormattedPhone';
import { EReportStatus } from '../../constants/report';
import { withVisibleInReportStatus } from '../../utils/report';

export const AgentContactsContainer_: React.FC = () => {
  const [isOpenPhone, setIsOpenPhone] = React.useState(false);
  const isDesktop = useIsDesktop();
  const { phone } = useSelector(getAuthor);

  const onOpenPhone = React.useCallback(() => {
    setIsOpenPhone(true);
  }, []);

  if (!phone) {
    return null;
  }

  const formattedPhone = getFormattedPhone(phone);

  return (
    <AgentContacts
      onOpenPhone={onOpenPhone}
      isDesktop={isDesktop}
      formattedPhone={formattedPhone}
      isOpenPhone={isOpenPhone}
      phone={phone}
    />
  );
};

AgentContactsContainer_.displayName = 'AgentContactsContainer';

export const AgentContactsContainer = withVisibleInReportStatus({
  notIn: [EReportStatus.Preview, EReportStatus.Share],
})(AgentContactsContainer_);
